import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { Assessment } from '../entities/Assessment'

@InputType()
export class ScanAnswerKeyArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => String)
  imageUrl: string
}

export interface IScanAnswerKey extends IAction<Assessment, ScanAnswerKeyArgs> {}
